import { useContext } from "react";
import { ThemeProviderContext } from "../components/theme-provider";
import type { ThemeProviderState } from "../lib/theme";

export function useTheme(): ThemeProviderState {
  const context = useContext(ThemeProviderContext);

  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }

  return context;
}
